/** Session key: message typed on `/home` to open in chat after navigating to the app. */
export const START_PAGE_PENDING_MESSAGE_KEY = 'atrium:startChatMessage'

/** When `'1'`, the seeded message is sent automatically (first turn) instead of only filling the composer. */
export const START_PAGE_AUTO_SEND_KEY = 'atrium:startChatAutoSend'

/** Detected flow intent from the homepage message (campaign | video | brand). */
export const START_PAGE_FLOW_INTENT_KEY = 'atrium:startFlowIntent'
